import { Albert } from '../../icons'

const Error = () => (
  <div className='w-full flex justify-center items-center my-[40px] px-12 md:px-0'>
    <div className='mx-auto flex flex-col items-center justify-center sm:px-10'>
      <Albert className='h-[380px] sm:h-[400px] md:h-[500px] lg:h-[600px] xl:h-[667px]' />
      <h1 className='text-[#020251] font-bold text-[40px]'>Page not found</h1>
      <p className='text-[#6E7785] text-[20px] max-w-3xl mt-4 justify-self-center'>
        We couldn't find the page you were looking for. Try going back or
        returning to home.
      </p>
      <button className='bg-[#020251] text-white mt-10 py-[12px] px-[16px] shadow-[0px_1px_4px_0px_rgba(0, 0, 0, 0.25)] rounded-[8px] hover:text-[#65C2D7]'>
        Report broken link
      </button>
    </div>
  </div>
)

export default Error
